import { StreamHandler } from "./stream.handler";
import { SubscribeSprintMissionPool, UpdateSprintMissionPool } from "@/types";
import type { SprintMissionPoolSchema } from "@/types";
import { useAppStore } from "@/stores";
import { recomputeSprintMissions } from "@/stores/derive";

/**
 * `sprint_mission_pool` — the Sprint-Mission-specific volatile stream: the shared
 * prizes-remaining counter per pooled campaign. Feeds `sprintMissionPoolById`; the assembled
 * `sprintMissions` view is re-derived on change.
 *
 * Shared, not per-player: the counter is identical for everyone, which is why the backend gives
 * it its own stream rather than a field on `mission_progress`.
 */
export class SprintMissionPoolHandler extends StreamHandler<
  SprintMissionPoolSchema[]
> {
  protected readonly subscribeType = SubscribeSprintMissionPool;
  protected readonly updateType = UpdateSprintMissionPool;

  protected isBusy(): boolean {
    const s = useAppStore.getState().sprintMissionPoolStream;
    return s.subscribed || s.loading;
  }
  protected setLoading(loading: boolean): void {
    useAppStore.getState().setSprintMissionPoolLoading(loading);
  }
  protected setSubscribed(subscribed: boolean): void {
    useAppStore.getState().setSprintMissionPoolSubscribed(subscribed);
  }
  protected clear(): void {
    useAppStore.getState().clearSprintMissionPool();
    recomputeSprintMissions();
  }
  protected apply(data: SprintMissionPoolSchema[]): void {
    useAppStore.getState().setSprintMissionPool(data);
    recomputeSprintMissions();
  }
}

export const sprintMissionPoolHandler = new SprintMissionPoolHandler();
